customElements.define('pdp-on-display', class extends HTMLElement {
    constructor() {
        super();
    }

    calcGeoDistance(lat1, lon1, lat2, lon2) {
        const toRad = angle => angle * Math.PI / 180;
        const earthRadius = 3959; // 英里，公里用 6371
        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const lat1Rad = toRad(lat1);
        const lat2Rad = toRad(lat2);

        const a = Math.sin(dLat/2) ** 2 +
                Math.cos(lat1Rad) * Math.cos(lat2Rad) *
                Math.sin(dLon/2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return +(earthRadius * c).toFixed(0);
    }

    async getCurrentPosition(storeList, callback) {
        this.loading(true)
        console.log('2. get current position');
        try {
            // Use Google Maps Geocoding API to get the latitude and longitude of the zipcode
            const apiKey = window.MOR_GOOGLE_MAPS_KEY;
            const zipCode = this.currentZipcode || getCookie('mor_zipcode');
            const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`);
            if (response.ok) {
                const data = await response.json();
                if (data.status === 'OK' && data.results.length > 0) {
                    const location = data.results[0].geometry.location;
                    const userLat = location.lat;
                    const userLng = location.lng;

                    storeList.forEach(store => {
                        if (store.latitude && store.longitude) {
                            store.distance = this.calcGeoDistance(userLat, userLng, store.latitude, store.longitude);
                        } else {
                            store.distance = null;
                        }
                    });

                    storeList.sort((a, b) => {
                        if (a.distance === null) return 1;
                        if (b.distance === null) return -1;
                        return a.distance - b.distance;
                    });
                }
            } else {
                console.warn('Google Maps API request failed:', response.status);
            }
        } catch (error) {
            console.error('Failed to get zipcode geolocation:', error);
        } finally {
            if (callback && typeof callback === 'function') {
                callback(storeList)
            }
        }
    }

    getDisplayStoreData() {
        const _storeKeys = Object.keys(this.displayData);
        const displayedStore = []

        for (const _storeCode of _storeKeys) {
            const store = this.displayData[_storeCode];
            if (store.onDisplay === 'Y') {
                const storeInfo = this.storeList.find(s => s['store-cd'] === _storeCode);
                if (storeInfo) {
                    displayedStore.push(storeInfo);
                }
            }
        }

        return displayedStore;
    }

    _renderStoreItem() {
        const storeTemplate = this.modal.querySelector('[data-store-list-item-template]');
        const storeListContainer = this.modal.querySelector('[data-store-list-container]');
        const displayedStore = this.getDisplayStoreData();

        this.getCurrentPosition(displayedStore, () => {
            console.log('3. render store', displayedStore)

            displayedStore.sort((a, b) => {
                if (!a.distance) return 1;
                if (!b.distance) return -1;
                return a.distance - b.distance;
            });
            // Clear the existing store list
            storeListContainer.innerHTML = '';

            // Remove warehouse
            const _displayedStore = displayedStore.filter(store => !store['store-cd'].startsWith('W'))

            // Render the displayed stores
            _displayedStore.forEach(store => {
                const storeItem = storeTemplate.content.cloneNode(true);
                if (store['store-cd'] === this.currentStoreCode) {
                    storeItem.firstElementChild.classList.add('current-store');
                }
                storeItem.querySelector('[data-address]').textContent = store['city'] + ', ' + store['st'];
                store['distance'] 
                    ? storeItem.querySelector('[data-distance]').textContent = store['distance'] 
                    : storeItem.querySelector('.store-distance').classList.add('hidden');
                storeItem.querySelector('[data-zipcode]').setAttribute('data-zipcode', store['zip-cd']);
                storeItem.querySelector('[data-store-code]').setAttribute('data-store-code', store['store-cd']);
                if (store['store-cd']) {
                    const firstLetterOfStoreCode = store['store-cd'].charAt(0).toUpperCase();
                    storeItem.querySelector('[data-warehouse-code]').setAttribute('data-warehouse-code', 'W' + firstLetterOfStoreCode);
                }
                storeItem.querySelector('[data-store-name]').setAttribute('data-store-name', store['store-name']);
                storeListContainer.appendChild(storeItem);
            });
            console.log('4. render end')
            this.loading(false);
        });
    }

    renderDisplayedStoreList() {
        this.loading(true);
        console.log('1. Start to render displayed store list');
        this.currentZipcode = getCookie('mor_zipcode')

        if (this.currentZipcode && this.modal.querySelector('[data-zipcode]')) {
            this.modal.querySelector('[data-zipcode]').textContent = this.currentZipcode;
        }
        this._renderStoreItem()
    }

    bindClickEvent() {
        const modalOpeners = this.querySelectorAll('modal-opener');
        const _this = this

        modalOpeners.forEach(opener => {
            this.openerId = opener.getAttribute('data-modal');
            opener.addEventListener('click', _this.renderDisplayedStoreList.bind(_this));
        })
    }

    loading(isLoading) {
        const addLoadingWrapper = this.modal.querySelector('.display-store-list');

        if (isLoading) {
            addLoadingWrapper.querySelector('.loading__spinner').classList.remove('hidden');
        } else {
            addLoadingWrapper.querySelector('.loading__spinner').classList.add('hidden');
        }
    }

    renderDom() {
        this.currentStoreCode = getCookie('mor_store_code')

        if (this.displayData && this.currentStoreCode) {
            const currentStoreDisplayInfo = this.displayData[this.currentStoreCode]
            this.isDisplayed = currentStoreDisplayInfo ? currentStoreDisplayInfo.onDisplay === 'Y' : false;
            if (this.isDisplayed) {
                this.classList.add('displayed');
            } else {
                this.classList.remove('displayed');
            }
        }

        const currentStoreInfo = this.storeList.find(store => store['store-cd'] === this.currentStoreCode);
        if (currentStoreInfo) {
            this.currentStoreAddress = currentStoreInfo['city']+','+currentStoreInfo['st'];
            this.querySelector('[data-current-store-address]').textContent = this.currentStoreAddress;
        }
    }

    connectedCallback() {
        const displayDataString = this.querySelector('script[data-display-info]');
        const storeListString = this.querySelector('script[data-store-list]');
        this.modal = document.querySelector('.pdp-on-display-modal');
        this.displayData = []
        this.storeList = []

        if (displayDataString) {
            try {
                this.displayData = JSON.parse(displayDataString.textContent);
                // console.log('Display data:', this.displayData);
                // console.log('Current store code:', this.currentStoreCode);

                this.bindClickEvent()

                if (storeListString) {
                    this.storeList = JSON.parse(storeListString.textContent);
                    // console.log('Store list:', this.storeList);
                }
                
                this.renderDom()
            } catch (error) {
                console.error('Error parsing display data:', error);
            }
        }
    }

})

const learnMoreButton = document.querySelector('.on-display-learn-more button');
if (learnMoreButton) {
    learnMoreButton.addEventListener('click', () => {
        const shoppingMethodsPopupTrigger = document.querySelector('modal-opener[data-modal="#PopupModal-pdpShippingMethods"] button');
        if (shoppingMethodsPopupTrigger) {
            shoppingMethodsPopupTrigger.click();
        }
    });
}